type GoogleResponse = {
  formattedPhoneNumber: string
  formattedAddress: string
  name: string
  latitude: string
  longitude: string
}

export type ServiceListData = {
  business_type_id: number
  country_iso_code: string
  businesses: ServiceListBusiness[]
}

export type ServiceListBusiness = {
  id: string
  name: string
  subtext: string
  image: string
  rating: number
  open: boolean
  pickup: boolean
  delivery: boolean
  lat: string
  long: string
  disclaimer: string
  slug: string
  keywords: string[] // You might want to specify the type for keywords and special if possible
  special?: any
  delivery_hours: {
    Day: string
    Time: {
      StartTime: string
      EndTime: string
    }
  }[]
  distance_in_miles: number
  distance_in_km: number
  is_custom_order_business: boolean
  show_delivery_methods: boolean
  custom_order_info:{
    AllowCustomOrderUpload:boolean
    BusinessId:string
    BusinessName:string
    Id:number
    LinkDisplayText:string
    Notes:string
  }
}

export type Region = {
  id: number
  name: string
  seo_description: string
  seo_title: string
  service_messages: any[]
  services: {
    icon: string
    id: number
    name: string
    seo_description: string
    seo_title: string
    slug: string
  }[]
  slug: string
}

export enum OrderSteps {
  PICKUP_ADDRESS = 1,
  DESTINATION_ADDRESS = 2,
  SERVICE_TIME = 3,
  DELIVERY_CONFIRMATION = 4,
  ORDER_SUMMARY = 5,
  PAYMENT = 6
}

export type BillingPayment = {
  accountNumber: string
  accountName: string
  amount: string
  notes: string
}

export enum DeliveryPlace {
  COORDINATE = 'COORDINATE',
  CUSTOM = 'CUSTOM',
  PROFILE_ADDRESS = 'PROFILE_ADDRESS'
}

export type Island = {
  label: string
  value: number
}

export type Parish = {
  Parish: string
  Villages: string[]
}

export type City = {
  id: number
  name: string
  parishes: Parish
}

export type AddressDetails = {
  town: string
  parish: string
  parishTown: string
  // TODO: Island accepts '' actually i gave string for quick solution
  island: Island | string
  googleResponse?: GoogleResponse
  address: string
  // TODO: Island accepts '' actually i gave string for quick solution
  deliveryPlace: DeliveryPlace | string
  filteredParishes: never[]
  streetDetails: string
  latitude?: number
  longitude?: number
}

export type CountryListItem = {
  code: string
  country: string
  dialCode: string
  flag?: string
  custom?: boolean
}

export enum DeliveryType {
  PICK_UP = 'pickup1',
  DELIVER = 'deliver1'
}

export enum ServiceTime {
  ASAP = 'ASAP1',
  LATER = 'LATER1'
}

export type DeliverDetails = {
  name: string
  additionalInfo: string
  phone: string
  deliveryNotes: string
  tip: {
    isPercentage: boolean
    amount: string
  }
  serviceTime: ServiceTime | null
  orderNotes: string
  finalDeliveryOption: DeliveryPaceOption | null
  deliveryPaceOptions: DeliveryPaceOption[]
  paymentType: string
  serviceFee: number
  deliveryType: DeliveryType | null
  totalPrice: number
  totalTax: number
  destinationAddress: AddressDetails
  pickupAddress: AddressDetails
  deliveryDate: string
  phoneDialDetails: CountryListItem | null
  showPhoneNumberInputArea: boolean
}

export type DeliveryPaceOption = {
  Amount: number
  CalculatedFee: number
  DeliveryTypeName: string
  Description: string
  ID: number
  IsPercent: true
}

export type RestaurantDetails = {
  id: string
  location_id: number
  merchant_id: string
  name: string
  seo_title: string
  seo_description: string
  subtext: string
  image: string
  rating: number
  redirect_to_app: boolean
  pickup: boolean
  delivery: boolean
  currency: string
  lat: string
  long: string
  open: boolean
  pickup_fee: number
  address: string
  special: any[]
  taxes: any[]
  business_type_id: number | null
  accepts_orders_when_closed: boolean
  accepts_credit_card: boolean
  accepts_paypal: boolean
  accepts_caribepay: boolean
  service_fees: any[]
  country_iso_code: string
  supports_cash_on_delivery: boolean
  supports_mmg: boolean
  supports_bitcoin: boolean
  uses_two_destinations: boolean
  uses_single_item_checkout: boolean
  keywords: string[]
  delivery_hours: any[]
  opening_hours: any[]
  categories: any[]
  is_bill_payment: boolean
  scheduling_info: SchedulingInfo;
}

export type SchedulingInfo = {
  LocationId: string;
  LocationOffset: number;
  BusinessTypeId: number;
  BusinessLocalTime: string;
  BufferInMinutes: number;
  AllowSchedulingWhenClosed: boolean;
}

export type ProductOption = {
  id: string
  name: string
  description: string
  required: boolean
  max_select: number
}

export type Product = {
  id: number
  name: string
  description: string
  image: string
  currency: string
  available: boolean
  price: number
  options: ProductOption[]
}

export type OrderStage = {
  StageColor: string
  StageDescription: string
  StageIcon: string
  StageName: string
  StatusId: number
  IsExecuted: boolean
}

export enum ORDER_STATUS {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELED = 9,
  ONTHEWAY = 5,
  ALMOSTTHERE = 6,
  COMPLETED_STAGE = 8
}

type Poi = {
  Icon: string
  Lat: string | null
  Lng: string | null
  Title: string
  UsedToCenterMap: boolean
}

export type SingleOrderStatus = {
  datetime_local: string
  datetime_original: string
  id: number
  pois: Poi[]
  restaurant_name: string
  stages: OrderStage[]
  tracking_url: string | null
  completion_estimate: string
  invoice_url: string
  delivery_address: string
  delivery_notes: string
  centeredPoi: Poi
  is_completed: boolean
  is_rejected: boolean
  status: number
}

export type AllOrderDetails = SingleOrderStatus & {
  stageStatus: number
  orderStatus: ORDER_STATUS
}

export type CustomerStatusUpdate = {
  Completed: boolean
  OrderCompletionEstimate: string
  OrderNumber: number
  Rejected: boolean
  StageId: number
  Stages: OrderStage[]
}

export type ProfileInfo = {
  Email: string
  EmailConfirmed: boolean
  FirstName: string
  Id: string
  IsPhoneNumberDefault: boolean
  LastName: string
  PhoneNumber: string | null
  PhoneNumber2: string | null
  PhoneNumber2Confirmed: boolean
  PhoneNumberConfirmed: boolean
  UserName: string
  customerAddresses: {
    UserId: string
    Latitude: string
    Longitude: string
    Address: string
    Name: string
    DeliveryNotes: string
    LocationId: number
    BusinessTypeId: number
  }[]
}
